import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataService } from '../shared/dataService';
import { AttLog } from '../shared/interfaces/attLog';
import { interval, Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-att-log',
  templateUrl: './att-log.component.html',
  styleUrls: ['./att-log.component.css']
})


export class AttLogComponent implements OnInit ,OnDestroy
{

  public dataSource: any[];
  public startDate : Date = new Date(Date.now());
  public endDate : Date = new Date(Date.now());
  public startDatestring : string; 
  public endDatestring : string;
  public subscriptionAttLog: Subscription;
  
  public  source = interval(20000); 
  
  constructor(private data: DataService,private router: Router) 
  {
    if (this.data.loginRequired)
    {
        console.log("redireccionar a el inicio de sesión")
        this.router.navigate(["/account"]);
    }
    console.log("AttLogComponent"); 
   }
   public allMode = 'page';
   public editorOptions: boolean;
   public checkBoxesMode = 'always'; //"onClick" | "onLongTap" | "always"
   public currentFilter: any = "onClick";
  ngOnInit(): void
  {
    this.editorOptions = true;  
    this.allMode = 'allPages';
      this.startDate.setDate( (this.startDate.getDate()- 20));
      this.initDataSource();
      this.subscriptionAttLog =  this.source.subscribe(val =>  
        {
            this.initDataSource()
        });      
  }
  ngOnDestroy(): void
  {
        console.log("ngOnDestroy AttLogComponent");
        if(this.subscriptionAttLog!= null && this.subscriptionAttLog != undefined)
            this.subscriptionAttLog.unsubscribe();
  };
  
  public onAttLogSend()
  {
      this.subscriptionAttLog.unsubscribe();
      console.log("onAttLogSend");
      this.initDataSource();
      this.subscriptionAttLog =  this.source
                                    .subscribe(val =>
                                            this.initDataSource()
                                            );
  }

  private initDataSource()
  {
    this.startDatestring = this.startDate.getFullYear().toString() + "-"  
                    + ((this.startDate.getMonth()+1).toString().length> 1 ? (this.startDate.getMonth()+1).toString() : '0' + (this.startDate.getMonth()+1)) +'-' 
                    + (this.startDate.getDate().toString().length> 1? this.startDate.getDate().toString(): '0' + this.startDate.getDate().toString());
                    //+ this.startDate.getDate().toString();
    this.endDatestring  = this.endDate.getFullYear().toString() + "-"  
                    + ((this.endDate.getMonth()+1).toString().length> 1 ? (this.endDate.getMonth()+1).toString() : '0' + (this.endDate.getMonth()+1).toString()) +'-' 
                    + (this.endDate.getDate().toString().length> 1? this.endDate.getDate().toString(): '0' + this.endDate.getDate().toString());
                    //+ this.endDate.getDate().toString();
    //console.log(this.startDatestring + " - " + this.endDatestring);
      this.data.loadAttLogs(this.startDatestring,this.endDatestring)
          .subscribe(sucess => {
              if (sucess) 
              {   
                console.log(this.data.attLog);
                  this.dataSource = this.data.attLog; 
                  console.log("initDataSource"); 
              }
          });
  }

}
